export default __webpack_public_path__ + "static/media/t-shirts-small.d67d1058.png";